<template>
    <component :result="result" :is="componentName"></component>
</template>

<script>
    import SearchShopPages from "./SearchShopPages";
    import SearchShopItems from "./SearchShopItems";

    export default {
        name: "ShopSearchResults",
        components: {SearchShopItems, SearchShopPages},
        props: {
            result: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        computed: {
            componentName() {
                return 'search-' + this.result.indexName.split('.')
                    .slice(-1)
                    .pop()
                    .replace('_', '-')
            }
        },
        methods: {}
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ShopSearchResults.vue?1b5ecd57